export interface IAppInsatalledOnDevice {
  timeCreated: Date;
  timeUpdated: Date;
  createdBy: Date;
  updatedBy: Date;
  appName: string;
  appVersion: string;
  merchantEntityUid: string;
  appmarketAppId: string;
  assignmentType: string;
  assignmentBundleId: string;
  assignmentStatus: string;
  deploymentStatus: string;
  deploymentUninstallStatus: string;
  appVersionId: string;
  price: number;
  pricingModel: string;
}
export interface PoiApps {
  poiUid: string;
  apps: IAppInsatalledOnDevice[];
}
